import React, { useContext } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../Contexts/AuthContext/AuthProvider';

function getCookie(name) {
    const cookieValue = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return cookieValue ? cookieValue.pop() : '';
}


const AdminPrivateRoute = ({ children }) => {

    // const { authUser, isLoading, token } = useContext(AuthContext);


    const [token, setToken] = useState(getCookie('PCX_STORE_admin_token'));
    const location = useLocation();
    // const [data, setData] = useState([]);
    // useEffect(() => {
    //     if (authUser?._id) {
    //         fetch(`https://api.wlffinance.org/api/admin/auth/view/${authUser?._id}?deviceId=${authId?.deviceId}`, {
    //             method: 'GET',
    //             headers: {
    //                 Authorization: `Bearer ${token}`,
    //             },
    //         })
    //             .then((res) => res.json())
    //             .then((data) => {
    //                 setData(data.data)
    //             })
    //     }
    // }, [])

    // if(isLoading){
    //     return <></>;
    // }

    if (!token) {
        return <Navigate to='/' sate={{ from: location }} replace ></Navigate>

    } else {
        if (token) {
            return children;
        } else {
            <Navigate to='*' sate={{ from: location }} replace></Navigate>
        }
    }



}

export default AdminPrivateRoute;